// AUTOGENERATED
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Restaumatic$dAnalytics$dTypes$dFindAddressResult from "../Restaumatic.Analytics.Types.FindAddressResult/index.js";
import * as Restaumatic$dAnalytics$dTypes$dOrigin from "../Restaumatic.Analytics.Types.Origin/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unscramble from "../Unscramble/index.js";
const originIsSymbol = {reflectSymbol: () => "origin"};
const resultIsSymbol = {reflectSymbol: () => "result"};
const FindAddressIsSymbol = {reflectSymbol: () => "FindAddress"};
const FindAddress = x => x;
const toFillFormTypeFindAddress = {fillFormDataType: v => "unknown"};
const newtypeFindAddress_ = {Coercible0: () => {}};
const hasFieldFindAddress = dictHasField => dictHasField;
const eqFindAddress = {
  eq: x => y => (() => {
    if (x.origin.tag === "Cart") { return y.origin.tag === "Cart"; }
    if (x.origin.tag === "Checkout") { return y.origin.tag === "Checkout"; }
    if (x.origin.tag === "FulfillmentSettings") { return y.origin.tag === "FulfillmentSettings"; }
    if (x.origin.tag === "RestaurantSelection") { return y.origin.tag === "RestaurantSelection"; }
    return false;
  })() && Restaumatic$dAnalytics$dTypes$dFindAddressResult.eqFindAddressResult.eq(x.result)(y.result)
};
const genericFindAddress = {to: x => x, from: x => x};
const showFindAddress = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        "{ origin: " + Restaumatic$dAnalytics$dTypes$dOrigin.showOrigin.show(v.origin) + ", result: " + Restaumatic$dAnalytics$dTypes$dFindAddressResult.showFindAddressResult.show(v.result) + " " + "}"
      ]
    })(FindAddressIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeFindAddress = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(originIsSymbol)(Restaumatic$dAnalytics$dTypes$dOrigin.unscrambleDecodeOrigin)(Unscramble.decodeRecordCons(resultIsSymbol)(Restaumatic$dAnalytics$dTypes$dFindAddressResult.unscrambleDecodeFindAddressResult)(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodeFindAddress = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericFindAddress)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(FindAddressIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(resultIsSymbol)({
      encodeWithOptions: v => Restaumatic$dAnalytics$dTypes$dFindAddressResult.encodeFindAddressResult.encode
    }))(originIsSymbol)({encodeWithOptions: v => Restaumatic$dAnalytics$dTypes$dOrigin.encodeOrigin.encode});
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeFindAddress = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericFindAddress)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(FindAddressIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(resultIsSymbol)({
    decodeWithOptions: v => Restaumatic$dAnalytics$dTypes$dFindAddressResult.decodeFindAddressResult.decode
  })())(originIsSymbol)({decodeWithOptions: v => Restaumatic$dAnalytics$dTypes$dOrigin.decodeOrigin.decode})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  FindAddress,
  FindAddressIsSymbol,
  decodeFindAddress,
  encodeFindAddress,
  eqFindAddress,
  genericFindAddress,
  hasFieldFindAddress,
  newtypeFindAddress_,
  originIsSymbol,
  resultIsSymbol,
  showFindAddress,
  toFillFormTypeFindAddress,
  unscrambleDecodeFindAddress
};
